// 取得個人專屬方案結果request model
export interface UserPlanRequest {
  /**基本資料**/
  orgNo: string; // 據點代碼：01：敦南 02：內湖 04：新竹 05：台南
  gender: string; // 性別（F：女 M：男）
  birthday: string; // 生日（YYYYMMDD)
  age: string; // 年齡
  femaleStatus?: boolean; // 懷孕狀態
  femaleMenopausal?: boolean; // 是否停經

  idNo: string; // 身份證號碼 身分證字號 / UUID 根據 identityType 對應填寫
  uuid?: string; // UUID  
  identityType?: string; // 身分資料類別 0：身分證字號（歷年體況）1：UUID（快速分析）
  funcType?: string; // 功能類別 0：預約過程 1：會員中心

  name: string; // 姓名
  cell: string; // 手機號碼
  email: string; // 電子信箱
  telH: string; // 家裡電話
  telO: string; // 公司電話
  zipCode: string; // 郵遞區號

  history: Array<string>; // 既往病史列表：既往病史_已勾選疾病名稱，若無勾選：既往病史_以下皆無，其他：既往病史_其他
  family: Array<string>; // 家族病史列表
  subjectiveSymptoms: Array<string>; // 自覺症狀

  fractureAnswer?: string;
  cancerAnswer?: string;
}

// 健康調查表表格response model
export interface QuestionnaireForm {
  questionnaireType: string; //健調表類型（個人病史／家族病史／自覺症狀）
  questionnaireTypeXCode: string; //健調表類型代號：個人病史：personalhistory 家族病史：familyhistory 自覺症狀：symptom
  diseaseGroups: Array<DiseaseGroup>; // 健調表欄位群組
}

// 健調表欄位
export interface DiseaseGroup {
  diseaseType: string; // 疾病類型（畫面顯示用）
  questionId: string; // 疾病類型代碼（後端回傳用）
  diseaseOptions: Array<DiseaseOption>; // 疾病選項群組
}

/**
 * CB-022 儲存健調表請求
 */
export interface SaveQuestionnaireRequest {
  idNo: string;
  companyNo?: string;
  caseNo: string;
  questionnaireId: number;  // 固定 20
  entQuestionnaireId: number;  // 固定 681
  questions: Questions[];
}

// 健檢日期跟狀態 response model
export interface AppointmentInfoResponse {
  bookDate: string;      // 健檢日期 (YYYYMMDD 格式，如: "20250601")
  bookStatus: string;    // 預約狀態 ("1":正常, "3":已報到, "8":已列印報告, "9":已寄發報告)
  caseNo?: string;       // 案件編號
}

// 預約狀態 response model
export interface AppointmentStatus {
  bookStatus: string;         // 預約狀態 ("1":正常, "3":已報到, "8":已列印報告, "9":已寄發報告)
  bookDate: string;           // 健檢日期 (YYYYMMDD 格式，如: "20250601")
  caseNo?: string;            // 案件編號
  isBookDatePassed: boolean;  // 健檢日期是否已過
  statusDescription: string;  // 預約狀態描述

  // 預約狀態判斷
  isBooked: boolean;            // 是否已預約
  isCheckedIn: boolean;         // 是否已報到
  isReportGenerated: boolean;   // 是否已列印報告
  isReportSent: boolean;        // 是否已寄發報告

  // 特殊狀態
  isOverdueAndNotCheckedIn: boolean; // 已預約但未報到且健檢日已過
}

// 預約狀態常數
export const BOOK_STATUS = {
  NORMAL: '1',           // 正常
  CHECKED_IN: '3',       // 已報到
  REPORT_PRINTED: '8',   // 已列印報告
  REPORT_SENT: '9'       // 已寄發報告
} as const;

// 健調表狀態
export type QuestionnaireStatus = 'AVAILABLE' | 'NOT_NEEDED' | 'WAITING' | 'OVERDUE' | 'COMPLETED';

// 疾病選項
export interface DiseaseOption {
  name: string; // 疾病名稱（畫面顯示用）
  choiceId: string; // 疾病類型代碼（後端回傳用
  answer: string; // 疾病一般詳細代碼（後端回傳用
  detailPlaceholder?: string; // 疾病詳細說明placeholder
  detailPlaceholderId?: string; // 疾病詳細說明回傳後端API之ID
}

export interface QuestionnaireResponse {
  // QuestionnaireResponse
  questionnaireId: string; // 問卷 ID
  questions: Array<Questions>; // 問卷題目
}

// 大項分類
export interface Questions {
  questionId: string; // 題目 ID  ex.既往病史ID
  questionAnswers: Array<QuestionAnswers>; // 題目答案
}

// 小項分類
export interface QuestionAnswers {
  choiceId: string; // 選項 ID ex.高血壓ID
  answer: string; // 選項答案
}
